export default (value) => {
  if (!value) {
    return ''
  }

  return value.split('_').map(next => next.charAt(0).toUpperCase() + next.substr(1).toLowerCase()).join(' ')
}
